// frontend/src/modules/dissidio/pages/ConfigDissidio.js
import React, { useState, useEffect } from 'react';
import { FaSave, FaTimes, FaBell, FaCalendar, FaBuilding, FaUsers, FaHistory } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

function ConfigDissidio({ usuario }) {
  const empresaId = usuario?.empresa_id || 1;
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [config, setConfig] = useState({
    mes_data_base: '',
    dia_data_base: '',
    categoria: '',
    sindicato: '',
    sindicato_laboral: '',
    dias_antecedencia: 15,
    notificar_email: true,
    notificar_sistema: true
  });
  const [historico, setHistorico] = useState([]);
  const [alertas, setAlertas] = useState([]);

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const token = localStorage.getItem('token');

  const fetchConfig = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/dissidio/config/${empresaId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setConfig({
          ...config,
          ...data,
          mes_data_base: data.mes_data_base || '',
          dia_data_base: data.dia_data_base || ''
        });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchHistorico = async () => {
    try {
      const response = await fetch(`/api/dissidio/historico/${empresaId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setHistorico(data);
      }
    } catch (err) {
      console.error('Erro ao buscar histórico:', err);
    }
  };

  const fetchAlertas = async () => {
    try {
      const response = await fetch(`/api/dissidio/alertas/${empresaId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setAlertas(data);
      }
    } catch (err) {
      console.error('Erro ao buscar alertas:', err);
    }
  };

  useEffect(() => {
    fetchConfig();
    fetchHistorico();
    fetchAlertas();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfig({
      ...config,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`/api/dissidio/config/${empresaId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(config)
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Erro ao salvar configuração');
      }

      setSuccess('✅ Configuração salva com sucesso!');
      setTimeout(() => setSuccess(''), 3000);
      fetchConfig();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  };

  const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

  if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando...</div>;

  return (
    <div style={{ padding: isMobile ? '10px' : '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Cabeçalho */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center', 
        marginBottom: '20px',
        gap: '10px'
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: isMobile ? '20px' : '28px' }}>⚖️ Configuração de Dissídio</h2>
          <p style={{ color: '#6c757d', margin: '5px 0 0 0', fontSize: isMobile ? '13px' : '14px' }}>
            Configure a data-base da categoria para receber alertas com antecedência
          </p>
        </div>
        <button 
          onClick={() => window.location.href = '/dashboard'}
          style={{ 
            padding: isMobile ? '8px 16px' : '8px 16px', 
            backgroundColor: '#6c757d', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            justifyContent: 'center',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <FaTimes /> Voltar ao Dashboard
        </button>
      </div>

      {/* Mensagens */}
      {error && <div style={{ backgroundColor: '#ffebee', padding: isMobile ? '10px 15px' : '10px', borderRadius: '4px', color: '#c62828', marginBottom: '15px', fontSize: isMobile ? '13px' : '14px' }}>❌ {error}</div>}
      {success && <div style={{ backgroundColor: '#e8f5e9', padding: isMobile ? '10px 15px' : '10px', borderRadius: '4px', color: '#2e7d32', marginBottom: '15px', fontSize: isMobile ? '13px' : '14px' }}>✅ {success}</div>}

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr', 
        gap: isMobile ? '15px' : '20px' 
      }}>
        {/* Formulário de Configuração */}
        <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '25px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px', fontSize: isMobile ? '16px' : '18px' }}>
            <FaCalendar /> Data-Base da Categoria
          </h3>

          <form onSubmit={handleSubmit}>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', 
              gap: isMobile ? '10px' : '20px' 
            }}>
              <div>
                <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Mês da Data-Base *</label>
                <select
                  name="mes_data_base"
                  value={config.mes_data_base}
                  onChange={handleChange}
                  required
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }}
                >
                  <option value="">Selecione...</option>
                  {meses.map((mes, i) => (
                    <option key={i + 1} value={i + 1}>{mes}</option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Dia da Data-Base *</label>
                <input
                  type="number"
                  name="dia_data_base"
                  value={config.dia_data_base}
                  onChange={handleChange}
                  min="1"
                  max="31"
                  required
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }}
                />
              </div>

              <div>
                <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Categoria Profissional *</label>
                <select
                  name="categoria"
                  value={config.categoria}
                  onChange={handleChange}
                  required
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }}
                >
                  <option value="">Selecione...</option>
                  <option value="COMERCIARIOS">Comerciários</option>
                  <option value="INDUSTRIARIOS">Industriários</option>
                  <option value="BANCARIOS">Bancários</option>
                  <option value="METALURGICOS">Metalúrgicos</option>
                  <option value="QUIMICOS">Químicos</option>
                  <option value="EDUCACAO">Educação</option>
                  <option value="SAUDE">Saúde</option>
                  <option value="TRANSPORTE">Transporte</option>
                  <option value="CONSTRUCAO">Construção Civil</option>
                  <option value="OUTRO">Outro</option>
                </select>
              </div>

              <div>
                <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Sindicato Patronal</label>
                <input
                  type="text"
                  name="sindicato"
                  value={config.sindicato}
                  onChange={handleChange}
                  placeholder="Ex: Sindicato do Comércio"
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }}
                />
              </div>

              <div>
                <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Sindicato dos Trabalhadores</label>
                <input
                  type="text"
                  name="sindicato_laboral"
                  value={config.sindicato_laboral}
                  onChange={handleChange}
                  placeholder="Ex: Sindicato dos Comerciários"
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }}
                />
              </div>

              <div>
                <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Dias de Antecedência para Alerta</label>
                <input
                  type="number"
                  name="dias_antecedencia"
                  value={config.dias_antecedencia}
                  onChange={handleChange}
                  min="1"
                  max="60"
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px', fontSize: isMobile ? '13px' : '14px' }}
                />
                <small style={{ color: '#6c757d', fontSize: isMobile ? '11px' : '12px' }}>Recomendado: 15 dias</small>
              </div>
            </div>

            <div style={{ marginTop: '20px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '15px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: isMobile ? '13px' : '14px' }}>
                <input
                  type="checkbox"
                  name="notificar_email"
                  checked={config.notificar_email}
                  onChange={handleChange}
                />
                <FaBell /> Notificar por Email
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: isMobile ? '13px' : '14px' }}>
                <input
                  type="checkbox"
                  name="notificar_sistema"
                  checked={config.notificar_sistema}
                  onChange={handleChange}
                />
                <FaBell /> Notificar no Sistema
              </label>
            </div>

            <button
              type="submit"
              disabled={saving}
              style={{
                marginTop: '20px',
                padding: isMobile ? '8px 20px' : '10px 30px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: saving ? 'not-allowed' : 'pointer',
                fontSize: isMobile ? '13px' : '14px',
                width: isMobile ? '100%' : 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'center'
              }}
            >
              <FaSave /> {saving ? 'Salvando...' : 'Salvar Configuração'}
            </button>
          </form>
        </div>

        {/* Resumo e Alertas */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '15px' : '20px' }}>
          {/* Próximo Dissídio */}
          <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px', fontSize: isMobile ? '15px' : '18px' }}>
              <FaCalendar /> Próximo Dissídio
            </h3>
            {config.mes_data_base && config.dia_data_base ? (
              <div style={{ textAlign: 'center' }}>
                <p style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: 'bold', color: '#007bff' }}>
                  {config.dia_data_base} de {meses[config.mes_data_base - 1]}
                </p>
                <p style={{ color: '#6c757d', fontSize: isMobile ? '13px' : '14px' }}>
                  Categoria: {config.categoria || 'Não definida'}
                </p>
                <p style={{ color: '#6c757d', fontSize: isMobile ? '13px' : '14px' }}>
                  Alerta em: {config.dias_antecedencia} dias de antecedência
                </p>
              </div>
            ) : (
              <p style={{ textAlign: 'center', color: '#6c757d', fontSize: isMobile ? '13px' : '14px' }}>
                ⚠️ Configure a data-base da sua categoria
              </p>
            )}
          </div>

          {/* Alertas Ativos */}
          <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px', fontSize: isMobile ? '15px' : '18px' }}>
              <FaBell /> Alertas Ativos
            </h3>
            {alertas.filter(a => !a.lido).length > 0 ? (
              alertas.filter(a => !a.lido).map(alerta => (
                <div key={alerta.id} style={{ 
                  padding: isMobile ? '8px 10px' : '10px', 
                  backgroundColor: '#fff3cd', 
                  borderRadius: '4px', 
                  marginBottom: '10px',
                  border: '1px solid #ffc107'
                }}>
                  <p style={{ margin: 0, fontWeight: 'bold', fontSize: isMobile ? '13px' : '14px' }}>{alerta.titulo}</p>
                  <p style={{ margin: '5px 0 0 0', fontSize: isMobile ? '12px' : '14px', color: '#856404' }}>
                    {alerta.descricao}
                  </p>
                  <small style={{ color: '#856404', fontSize: isMobile ? '11px' : '12px' }}>
                    Faltam {alerta.dias_restantes} dias
                  </small>
                </div>
              ))
            ) : (
              <p style={{ textAlign: 'center', color: '#6c757d', fontSize: isMobile ? '13px' : '14px' }}>
                ✅ Nenhum alerta pendente
              </p>
            )}
          </div>

          {/* Histórico Resumido */}
          <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px', fontSize: isMobile ? '15px' : '18px' }}>
              <FaHistory /> Últimos Dissídios
            </h3>
            {historico.length > 0 ? (
              historico.slice(0, 3).map(item => (
                <div key={item.id} style={{ 
                  padding: isMobile ? '6px 0' : '8px 0', 
                  borderBottom: '1px solid #dee2e6' 
                }}>
                  <p style={{ margin: 0, fontSize: isMobile ? '13px' : '14px' }}>
                    <strong>{formatDate(item.data_dissidio)}</strong>
                    <span style={{ float: 'right', color: '#28a745', fontSize: isMobile ? '13px' : '14px' }}>
                      +{item.percentual_reajuste}%
                    </span>
                  </p>
                  <small style={{ color: '#6c757d', fontSize: isMobile ? '11px' : '12px' }}>
                    Próximo: {formatDate(item.data_proximo)}
                  </small>
                </div>
              ))
            ) : (
              <p style={{ textAlign: 'center', color: '#6c757d', fontSize: isMobile ? '13px' : '14px' }}>
                📭 Nenhum histórico registrado
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfigDissidio;